import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Interval } from './recurring_invoice/';

@Injectable()
export class IntervalMappingService {
  private translatedIntervalMap: { [k: string]: string | any } = {
    [Interval.DAY]: {
      '=1': this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.DAY'),
      other: this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.DAYS'),
    },
    [Interval.WEEK]: {
      '=1': this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.WEEK'),
      other: this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.WEEKS'),
    },
    [Interval.MONTH]: {
      '=1': this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.MONTH'),
      other: this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.MONTHS'),
    },
    [Interval.YEAR]: {
      '=1': this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.YEAR'),
      other: this.translateService.instant('BILLING.INVOICES_PAGE.RECURRING.INTERVAL.YEARS'),
    },
  };

  constructor(private translateService: TranslateService) {}

  public get intervalMapping(): { [k: string]: string } {
    return this.translatedIntervalMap;
  }
}
